// extracted by mini-css-extract-plugin
export default {"main_privacy":"PrivacyPolicy_main_privacy__4qQ33","info_privacy":"PrivacyPolicy_info_privacy__OGls3","content_privacy":"PrivacyPolicy_content_privacy__2ncLZ"};